// formSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    step: 1,
    values: {},
    OtpValidateRequired: false,
    lastStep: 1,
    email: '',
    backNavigationLocked: false,
    signupFlowRole: ''
};

const signupFormSlice = createSlice({
    name: 'signupForm',
    initialState,
    reducers: {
        nextStep(state) {
            state.step += 1;
        },
        prevStep(state) {
            state.step -= 1;
        },
        setStep(state, action) {
            state.step = action.payload;
        },
        setLastStep(state, action) {
            state.lastStep = action.payload;
        },
        setOtpValidateRequired: (state, action) => {
            state.OtpValidateRequired = action.payload;
        },
        updateValuesOnChange(state, action) {
            const { key, value } = action.payload;
            state.values[key] = value;
        },
        setEmailValue(state, action) {
            state.email = action.payload;
        },
        setBackNavigationLocked(state, action) {
            state.backNavigationLocked = action.payload;
        },
        setSignupFlowRole(state, action) {
            state.signupFlowRole = action.payload;
        },
        resetSignupForm(state) {
            return initialState;
        }
    }
});

export const {
    nextStep,
    prevStep,
    setStep, setLastStep,
    updateValuesOnChange,
    setOtpValidateRequired,
    setEmailValue,
    setBackNavigationLocked,
    setSignupFlowRole,
    resetSignupForm
} = signupFormSlice.actions;

// Export the reducer to be used in the store
export default signupFormSlice.reducer;


